import React from 'react';

/**
 * Unwraps the first level of React.Fragment children.
 *
 * This function takes a ReactNode, and if any of the children are a React.Fragment,
 * it replaces that React.Fragment with its children. This operation is only performed
 * on the first level of children and does not recurse into nested React.Fragments.
 *
 * @param children - The children to unwrap.
 * @returns An array of ReactNodes with the first level of React.Fragments unwrapped.
 */
export function unwrapFragments(children: React.ReactNode): React.ReactNode[] {
  return React.Children.toArray(children).flatMap((child) => {
    if (React.isValidElement(child) && child.type === React.Fragment) {
      const fragmentElement = child as React.ReactElement<{ children?: React.ReactNode }>;
      return React.Children.toArray(fragmentElement.props.children);
    }
    return child;
  });
}
